import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import SectionTitle from '../../elements/section-title/SectionTitle';
import DefaultFaqData from '../../data/psm/PSMFaqData.json';

const PSMFaqSection = ({ faqData }) => {
    const FaqData = faqData || DefaultFaqData;
    return (
        <div className="section section-padding psm-faq-section">
            <div className="container">
                <div className="row mb--40">
                    <div className="col-lg-12">
                        <SectionTitle
                            subtitle="FAQs"
                            title="Common questions from customers"
                            textAlignment="heading-center heading-light"
                            textColor=""
                        />
                    </div>
                </div>
                <div className="row align-items-center">
                    {/* Left Side - Image */}
                    <div className="col-lg-5 col-md-12 mb-5 mb-lg-0">
                        <div className="psm-faq-image-wrapper">
                            <img
                                src={process.env.PUBLIC_URL + "/images/banner/PSM-faq.png"}
                                alt="FAQ Illustration"
                                className="psm-faq-image"
                            />
                        </div>
                    </div>

                    {/* Right Side - Accordion */}
                    <div className="col-lg-7 col-md-12">
                        <div className="psm-faq-accordion">
                            <Accordion defaultActiveKey="1">
                                {FaqData.map((data) => (
                                    <Accordion.Item eventKey={data.id} key={data.id} className="psm-accordion-item">
                                        <Accordion.Header className="psm-accordion-header">
                                            <span className="psm-accordion-number">{`${data.id}.`}</span>
                                            {data.title}
                                        </Accordion.Header>
                                        <Accordion.Body className="psm-accordion-body">
                                            <p>{data.body}</p>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>

            <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1">
                    <img src={process.env.PUBLIC_URL + "/images/others/line-9.png"} alt="Circle" />
                </li>
                <li className="shape shape-2">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-42.png"} alt="Circle" />
                </li>
                <li className="shape shape-3">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-43.png"} alt="Circle" />
                </li>
            </ul>

            <style jsx>{`
                .psm-faq-section {
                    background-color: #26272b;
                    position: relative;
                }
                .psm-faq-image-wrapper {
                    text-align: center;
                    padding-right: 30px;
                }
                .psm-faq-image {
                    max-width: 100%;
                    height: auto;
                    width: 90%;
                }
                .psm-faq-accordion .accordion-item {
                    background-color: transparent;
                    border: none;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                    margin-bottom: 0;
                    padding: 20px 0;
                }
                .psm-faq-accordion .accordion-item:last-child {
                    border-bottom: none;
                }
                .psm-faq-accordion .accordion-button {
                    background-color: transparent;
                    color: #ffffff;
                    font-weight: 600;
                    font-size: 18px;
                    padding: 0;
                    box-shadow: none;
                    border: none;
                    display: flex;
                    align-items: center;
                    width: 100%;
                }
                .psm-faq-accordion .accordion-button::after {
                    filter: invert(1);
                    margin-left: auto;
                    flex-shrink: 0;
                }
                .psm-faq-accordion .accordion-button:not(.collapsed) {
                    color: #ffffff;
                    background-color: transparent;
                    box-shadow: none;
                }
                .psm-faq-accordion .accordion-button:focus {
                    box-shadow: none;
                    border: none;
                }
                .psm-accordion-number {
                    margin-right: 15px;
                    color: #ffffff;
                    font-weight: 700;
                    flex-shrink: 0;
                }
                .psm-accordion-body {
                    padding: 15px 0 0 35px;
                    color: #b9b9b9;
                    font-size: 16px;
                    line-height: 1.6;
                }
                .psm-faq-accordion .accordion-collapse {
                    border: none;
                }
                @media (max-width: 991px) {
                    .psm-faq-image-wrapper {
                        margin-bottom: 30px;
                        padding-right: 0;
                    }
                    .psm-faq-image {
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};

export default PSMFaqSection;